var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("stored-settings")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("common.close"),
                  expression: "$ct('common.close')",
                },
              ],
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.settings.length == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(_vm._s(_vm.$ct("no-settings-available"))),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-list" } },
        [
          _vm._l(_vm.settings, function (setting) {
            return _c(
              "w-list-item",
              { key: setting.ID },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(setting.Name))]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("use-settings"),
                            expression: "$ct('use-settings')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.useSettings(setting)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "check" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.edit"),
                            expression: "$ct('common.edit')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editSettings(setting)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.delete"),
                            expression: "$ct('common.delete')",
                          },
                        ],
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.deleteSettings(setting)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.createNewSettings()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [
                _vm._v(_vm._s(_vm.$ct("create-new-settings"))),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }